export default __webpack_public_path__ + "static/media/tree_w.0539226e.svg";